import Modal from './Modal';
import type { OrderHistoryEntry } from '../types';

interface CancelShipmentModalProps {
  isOpen: boolean;
  loading: boolean;
  order: OrderHistoryEntry | null;
  onClose: () => void;
  onConfirm: () => void;
}

function CancelShipmentModal({ isOpen, loading, order, onClose, onConfirm }: CancelShipmentModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Cancel Shipment" dismissible={!loading}>
      <p style={{ marginBottom: '20px' }}>
        Are you sure you want to request a cancellation/refund for this shipment?
      </p>
      {order && (
        <div
          style={{
            background: 'var(--champagne-dune)',
            padding: '16px',
            borderRadius: 'var(--radius-sm)',
            marginBottom: '20px',
          }}
        >
          <div>
            <strong>Recipient:</strong> {order.recipient}
          </div>
          <div>
            <strong>Tracking:</strong> {order.tracking_code || '-'}
          </div>
        </div>
      )}
      <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
        <button className="btn btn-ghost" onClick={onClose} disabled={loading}>
          Keep Shipment
        </button>
        <button
          className={`btn btn-danger ${loading ? 'loading' : ''}`}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? 'Cancelling...' : 'Request Refund'}
        </button>
      </div>
    </Modal>
  );
}

export default CancelShipmentModal;
